import { render } from "./Project.vue?vue&type=template&id=641e2c26"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\PC1\\Local Sites\\jpburato.now.sh.dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__